import { fetchJson } from '@helpCenter/util/fetch/fetch';
import { createResource, type RouterDataContext } from 'react-resource-router';
import type { RequestConversationResource } from './types';

export const requestConversationResource = createResource<RequestConversationResource>({
    type: 'REQUEST_CONVERSATION_RESOURCE',
    getKey: () => `request-conversation`,
    getData: async ({ match }: RouterDataContext) =>
        fetchJson(`/rest/api/3/issue/${match.params.requestKey || ''}/comment`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
            },
        }),
    maxAge: 0,
});
